const TELEFONO_POR_DEFECTO = '1111111111'
const PREFIJO_ARGENTINA = '54'
const LARGO_MINIMO_TELEFONO = 8

const normalizarTelefono = (valor) => `${valor ?? ''}`.replace(/\D/g, '')

export const obtenerTelefonoContacto = (vendedor) => {
  const celular = normalizarTelefono(vendedor?.celular)

  if (celular.length >= LARGO_MINIMO_TELEFONO) {
    return celular
  }

  const telefono = normalizarTelefono(vendedor?.telefono)

  return telefono.length >= LARGO_MINIMO_TELEFONO ? telefono : TELEFONO_POR_DEFECTO
}

export const armarLinkWhatsapp = (vendedor, mensaje = '') => {
  const telefono = obtenerTelefonoContacto(vendedor)
  const numero = telefono.startsWith(PREFIJO_ARGENTINA)
    ? telefono
    : `${PREFIJO_ARGENTINA}${telefono}`
  const texto = mensaje ? `?text=${encodeURIComponent(mensaje)}` : ''

  return `https://wa.me/${numero}${texto}`
}
